const _UTILS = {
  ConvertStringToHTML(str) {
    let parser = new DOMParser();
    let doc = parser.parseFromString(str, 'text/html');
    return doc.body;
  }
};

document.addEventListener('alpine:init', () => {
  Alpine.data('VariantRadios', () => ({
    section_id: '',
    init() {
      this.InitSelf();
      this.InitWatchers();
    },
    InitSelf() {
      let am = this;
      am.section_id = am.$el.dataset.sectionId;
    },
    InitWatchers() {
      let am = this;
      document.addEventListener('variantUrlChanged', (e) => {
        am.UpdateProductImages();
      });
    },
    async UpdateProductImages() {
      let am = this;
      let variant_url = `${window.location.href}&sections=${am.section_id}`
      let section_res = await fetch(variant_url).then(res => res.json());
      let $section = _UTILS.ConvertStringToHTML(section_res[am.section_id]);
      let $main_gallery = document.querySelector('media-gallery-new');
      let $res_gallery = $section.querySelector('media-gallery-new');
      $main_gallery.insertAdjacentElement('beforebegin', $res_gallery);
      $main_gallery.remove();

      // modal gallery
      let $modal_gallery = document.querySelector('#ProductModal-gallery');
      let $res_modal_gallery = $section.querySelector('#ProductModal-gallery');
      $modal_gallery.insertAdjacentElement('beforebegin', $res_modal_gallery);
      $modal_gallery.remove();
    }
  }));

  Alpine.data('ProductImages', () => ({
    init() {
      this.InitSwiper();
    },
    InitSwiper() {
      let am = this;

      let $thumbs = am.$el.querySelector('[data-thumbs-slider]');
      var swiper = new Swiper($thumbs, {
        spaceBetween: 10,
        slidesPerView: 4.5,
        freeMode: true,
        watchSlidesProgress: true,
      });

      let $main = am.$el.querySelector('[data-main-slider]');
      var swiper2 = new Swiper($main, {
        spaceBetween: 10,
        navigation: {
          nextEl: $main.querySelector('.swiper-button-next'),
          prevEl: $main.querySelector('.swiper-button-prev'),
        },
        thumbs: {
          swiper: swiper,
        },
      });    
    },
    e_ImageZoom(e) {
      // console.log(e, e.currentTarget);
      let $modal = document.querySelector('#ProductModal-gallery');
      let $modal_content = document.querySelector('#ProductModal-gallery .product-media-modal__content');
      $modal.setAttribute('open', '');
      let media_id = e.currentTarget.dataset.mediaId;
      let $media = $modal.querySelector(`[data-media-id="${media_id}"]`);
      $modal_content.scrollTo({
        top: $media.offsetTop - (document.documentElement.clientHeight * 0.1)
      });
    }
  }));
});